import MainLayout from "layouts";
import AdminAccount from "pages/accounts/admin/AdminAccount";
import CustomerAccount from "pages/accounts/customers/CustomerAccount";
import DistributorAccount from "pages/accounts/distributor/DistributorAccount";
import FillingPersonAccount from "pages/accounts/filling_person/FillingPersonAccount";
import MachineAdminAccount from "pages/accounts/machine_admin/MachineAdminAccount";
import AdImageManagement from "pages/advertisement/ad_images/AdImageManagement";
import AdVideoManagement from "pages/advertisement/ad_videos/AdVideoManagement";
import AdVidsInMachine from "pages/advertisement/ad_videos/in_machine/AdVidsInMachine";
import LocationManagement from "pages/inventory/location/LocationManagement";
import Login from "pages/Login";
import PaymentsManagement from "pages/payments/PaymentsManagement";
import ManageProducts from "pages/products/ManageProducts";
import ProductCategories from "pages/product_category/ProductCategories";
import ProductGrouping from "pages/product_grouping/ProductGrouping";
import ProductValidationManagement from "pages/product_validation/ProductValidationManagement";
import RefillProducts from "pages/refill/RefillProducts";
import SalesReport from "pages/reports/SalesReport";
import AlertManagement from "pages/third_party_services/alert_settings/AlertManagement";
import SmsProviderManagement from "pages/third_party_services/sms_provider/SmsProviderManagement";
import TraysAndPartition from "pages/trays_and_partition/TraysAndPartition";
import AdminProfile from "pages/user_profile/AdminProfile";
import DistributorProfile from "pages/user_profile/DistributorProfile";
import FillingPersonProfile from "pages/user_profile/FillingPersonProfile";
import MachineAdminProfile from "pages/user_profile/MachineAdminProfile";
import NewUserProfile from "pages/user_profile/NewUserProfile";
import SuperAdminProfile from "pages/user_profile/SuperAdminProfile";
import CabinList from "pages/vending/cabin/list/CabinList";
import MachineDetails from "pages/vending/machine/detail/MachineDetails";
import Machine from "pages/vending/machine/Machine";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Theme from "themes";
import ProtectedRoute from "utils/ProtectedRoute";
import "./App.css";
import NotificationList from "pages/notifications/NotificationList";
import Statistics from "pages/statistics/Statistics";
import MainStockManagement from "pages/inventory/main/MainStockManagement";
import MainStockLogs from "pages/inventory/main/logs/MainStockLogs";
import DistributorStockList from "pages/inventory/distributor/DistributorStockList";
import DistributorStockLogs from "pages/inventory/distributor/logs/DistributorStockLogs";
import LocationStockLogs from "pages/inventory/location/stock/logs/LocationStockLogs";
import ManageGlobalOffers from "pages/global_offers/ManageGlobalOffers";
import InvoicePdf from "pages/reports/InvoicePdf";
import InvoiceConfig from "pages/reports/InvoiceConfig";
import MainStockHistory from "pages/inventory/main/history/MainStockHistory";
import DistributorStockHistory from "pages/inventory/distributor/history/DistributorStockHistory";
import LocationStockHistory from "pages/inventory/location/history/LocationStockHistory";
import InventorySettings from "pages/inventory/settings/InventorySettings";
import LocationAdminAccount from "pages/accounts/location_admin/LocationAdminAccount";
import LocationAdminProfile from "pages/user_profile/LocationAdminProfile";
import FillingPersonStockList from "pages/inventory/fillingPerson/FillingPersonStockList";
import FillingPersonStockLogs from "pages/inventory/fillingPerson/logs/FillingPersonStockLogs";
import FillingPersonStockHistory from "pages/inventory/fillingPerson/history/FillingPersonStockHistory";
import AdminStockLogs from "pages/inventory/admin/logs/AdminStockLogs";
import AdminStockHistory from "pages/inventory/admin/history/AdminStockHistory";
import AdminStockManagement from "pages/inventory/admin/AdminStockManagement";
import LocationStockManagement from "pages/inventory/location/stock/LocationStockManagement";
import ChangePassword from "layouts/Header/HeaderContent/Settings/ChangePassword";
import FillingPersonStockReturns from "pages/inventory/fillingPerson/return/FillingPersonStockReturns";
import CustomerManagement from "pages/accounts/customer_profiles/CustomerManagement";
import ProductAnalytics from "pages/product-analytics/ProductAnalytics";

const items = [
  {
    name: "username",
    type: "text",
    required: true,
  },
  {
    name: "password",
    type: "text",
    required: true,
  },
];

function App() {
  return (
    <Theme>
      <BrowserRouter>
        <Routes>
          <Route
            path=""
            element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            }
          >
            <Route path="" element={<Statistics />} />
            <Route path="machines" element={<Machine />} />
            <Route path="machines/:m_id" element={<MachineDetails />} />
            <Route path="machines/:m_id/cabins" element={<CabinList />} />
            <Route path="machines/:m_id/refill" element={<RefillProducts />} />
            <Route path="machines/:m_id/ads" element={<AdVidsInMachine />} />
            <Route path="locations" element={<LocationManagement />} />
            <Route path="main-stock" element={<MainStockManagement />} />
            <Route path="inventory-settings" element={<InventorySettings />} />
            <Route path="main-stock/logs" element={<MainStockLogs />} />
            <Route path="product-analytics" element={<ProductAnalytics />} />
            <Route
              path="main-stock/history/:time"
              element={<MainStockHistory />}
            />
            <Route path="main-stock/history" element={<MainStockHistory />} />

            <Route path="admin-stock" element={<AdminStockManagement />} />
            <Route path="admin-stock/logs" element={<AdminStockLogs />} />
            <Route path="admin-stock/history" element={<AdminStockHistory />} />
            <Route
              path="distributor-stock"
              element={<DistributorStockList />}
            />
            <Route
              path="return-logs"
              element={<FillingPersonStockReturns />}
            />
            <Route
              path="distributor-stock/logs"
              element={<DistributorStockLogs />}
            />
            <Route
              path="distributor-stock/history"
              element={<DistributorStockHistory />}
            />

            <Route
              path="filling-allocation"
              element={<FillingPersonStockList />}
            />
            <Route
              path="filling-allocation/logs"
              element={<FillingPersonStockLogs />}
            />
            <Route
              path="filling-allocation/history"
              element={<FillingPersonStockHistory />}
            />

            <Route path="location-stock" element={<LocationStockManagement />} />
            <Route path="location-stock/logs" element={<LocationStockLogs />} />
            <Route
              path="location-stock/history/:time"
              element={<LocationStockHistory />}
            />
            <Route
              path="location-stock/history"
              element={<LocationStockHistory />}
            />

            <Route path="event-offers" element={<ManageGlobalOffers />} />
            <Route
              path="machines/:m_id/trays-n-partitions"
              element={<TraysAndPartition />}
            />

            <Route path="payment-methods" element={<PaymentsManagement />} />
            <Route path="sales-report" element={<SalesReport />} />
            <Route path="products" element={<ManageProducts />} />
            <Route path="product-category" element={<ProductCategories />} />
            <Route path="product-grouping" element={<ProductGrouping />} />
            <Route path="admin-accounts" element={<AdminAccount />} />
            <Route path="distributors" element={<DistributorAccount />} />
            <Route path="filling-persons" element={<FillingPersonAccount />} />
            <Route path="machine-admin" element={<MachineAdminAccount />} />
            <Route path="location-admin" element={<LocationAdminAccount />} />
            <Route path="customers" element={<CustomerAccount />} />
            <Route path="ad-images" element={<AdImageManagement />} />
            <Route path="ad-videos" element={<AdVideoManagement />} />
            <Route path="customer-profiles" element={<CustomerManagement />} />
            <Route path="sms-provider" element={<SmsProviderManagement />} />
            <Route path="alert-settings" element={<AlertManagement />} />
            <Route path="invoice-configuration" element={<InvoiceConfig />} />
            <Route
              path="admin-profile/:userProfileId"
              element={<AdminProfile />}
            />
            <Route
              path="distributor-profile/:userProfileId"
              element={<DistributorProfile />}
            />
            <Route
              path="filling-person-profile/:userProfileId"
              element={<FillingPersonProfile />}
            />
            <Route
              path="machine-admin-profile/:userProfileId"
              element={<MachineAdminProfile />}
            />
            <Route
              path="location-admin-profile/:userProfileId"
              element={<LocationAdminProfile />}
            />
            <Route
              path="super-admin-profile/:userProfileId"
              element={<SuperAdminProfile />}
            />
            <Route path="notifications" element={<NotificationList />} />
            <Route
              path="product-validation"
              element={<ProductValidationManagement />}
            />
            <Route path="change-password" element={<ChangePassword />} />
          </Route>
          <Route path="new-user-profile" element={<NewUserProfile />} />
          <Route path="login" element={<Login />} />
          <Route path="invoice/:uuid" element={<InvoicePdf />} />
          
        </Routes>
      </BrowserRouter>
    </Theme>
  );
}

export default App;
